import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enCommon from "@/locales/en/common.json";
import esCommon from "@/locales/es/common.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon },
      es: { common: esCommon },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "es"],
    defaultNS: "common",
    ns: ["common"],
    // escapeValue: false is safe here because React's JSX rendering already escapes all
    // interpolated values. Translations are static bundled files, never user-controlled.
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "wanderfit-backoffice.locale",
    },
  });

export { i18n };
